import { CancelConfirmModal } from 'app/components/cancel-confirm-modal';

interface BookingCancelModalProps {
  isOpen: boolean;
  bookingName: string;
  /** Formatted "Tomorrow · 5:30 pm". */
  when: string;
  isCancelling: boolean;
  isError: boolean;
  onConfirm: () => void;
  /** Keep the booking / dismiss (overlay click, Esc, or the "Keep booking" button). */
  onClose: () => void;
}

/**
 * Cancel-confirmation for a resource booking. Copy and test-id prefix only; {@link CancelConfirmModal}
 * owns the shape.
 *
 * The shared error line matters here as much as it does for events: the tile gates on a deadline
 * resolved when the booking was published, so helix can still refuse a cancellation the button offered.
 */
export const BookingCancelModal = ({
  isOpen,
  bookingName,
  when,
  isCancelling,
  isError,
  onConfirm,
  onClose,
}: BookingCancelModalProps): JSX.Element => (
  <CancelConfirmModal
    isOpen={isOpen}
    namespace="bookingCancel"
    testIdPrefix="booking-cancel"
    subject={{ booking: bookingName }}
    when={when}
    isCancelling={isCancelling}
    isError={isError}
    onConfirm={onConfirm}
    onClose={onClose}
  />
);
